import { Singleton, type SingletonInstance } from '@tunein/web-utils';
import { createBrowserHistory, type History } from 'history';

export class HistorySingleton extends Singleton<History> {
  init() {
    this.instance = createBrowserHistory();
  }
}

export const historySingleton = new HistorySingleton() as SingletonInstance<
  History,
  HistorySingleton
>;
